export const DEFAULT_NETWORK = 'hyperliquid';
export const NETWORKS = ['hyperliquid'];

export const ACTIVITY_EVENT = [
  {
    value: '',
    label: 'All events'
  },
  {
    value: 'Borrow',
    label: 'Borrow'
  },
  {
    value: 'LiquidationCall',
    label: 'Liquidation Call'
  },
  {
    value: 'Repay',
    label: 'Repay'
  },
  {
    value: 'Supply',
    label: 'Supply'
  },
  {
    value: 'Withdraw',
    label: 'Withdraw'
  },
  {
    value: 'BalanceTransfer',
    label: 'Balance Transfer'
  }
];

export const POOL_ACTIVITY_EVENT = [
  {
    value: '',
    label: 'All events'
  },
  {
    value: 'Borrow',
    label: 'Borrow'
  },
  {
    value: 'LiquidationCall',
    label: 'Liquidation Call'
  },
  {
    value: 'Repay',
    label: 'Repay'
  },
  {
    value: 'Supply',
    label: 'Supply'
  },
  {
    value: 'Withdraw',
    label: 'Withdraw'
  }
];
